/* global onBeforeUnmount */
// Cycles through `phrases`, typing/deleting one character at a time, and returns the current
// animated string as a ref. Used for animated placeholder-style text (search boxes, etc).
export function useTypewriter(phrases, options = {}) {
  const { typeSpeed = 55, deleteSpeed = 25, pauseMs = 1600 } = options
  const text = ref('')
  let timer = null

  function start() {
    let phraseIndex = 0
    let charIndex = 0
    let deleting = false

    function tick() {
      const current = phrases[phraseIndex]

      if (!deleting) {
        charIndex++
        text.value = `${current.slice(0, charIndex)}${charIndex < current.length ? '|' : ''}`
        if (charIndex === current.length) {
          deleting = true
          timer = setTimeout(tick, pauseMs)
          return
        }
      }
      else {
        charIndex--
        text.value = `${current.slice(0, charIndex)}|`
        if (charIndex === 0) {
          deleting = false
          phraseIndex = (phraseIndex + 1) % phrases.length
        }
      }

      timer = setTimeout(tick, deleting ? deleteSpeed : typeSpeed)
    }

    tick()
  }

  onMounted(() => start())
  onBeforeUnmount(() => clearTimeout(timer))

  return text
}
